import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { FormattedMessage, intlShape } from 'react-intl';
import { useInquiryPriceBreakdown } from './utils';

export const InquiryPriceBreakdown = ({
  quote,
  listing,
  profile,
  intl
}) => {
  const { total, lineItems } = useInquiryPriceBreakdown(quote, listing, profile, intl);

  return (
    <div className="inquiry-price-breakdown">
      <div className="breakdown-title no-margin heavier">
        <FormattedMessage
          id="inquiry_booking.inquiry_price_breakdown.title"
          defaultMessage="Cost Detail"
        />
      </div>
      {map(lineItems, (breakDownItem) => {
        if (breakDownItem) {
          const { label, tooltip, price } = breakDownItem;
          return (
            <div className="inquiry-breakdown-item flex space-between top">
              <div>
                <span className="margin-md-right">
                  {label}
                </span>
                {tooltip}
              </div>
              <div>
                {price}
              </div>
            </div>
          );
        }
        return null;
      })}
      <hr />
      <div>
        <div className="breakdown-total-label">
          {total.label}
        </div>
        <h5 className="no-margin heavier">
          {total.price}
        </h5>
      </div>
    </div>
  );
};

InquiryPriceBreakdown.propTypes = {
  quote: PropTypes.object,
  listing: PropTypes.object,
  profile: PropTypes.object,
  intl: intlShape
};
